import { CaptionStyles, CaptionLineConfig } from '../../types/asset-types';
import { getFontFullPath } from '../../utils/fontUtils';
import { TransitionInEffect } from '../../types/transitions';

const corporate: Partial<CaptionStyles> = {
  theme_preset: 'corporate',
  pageStyle: {
    color: '#ffffff',
    background: '#000000a6',
    borderRadius: '16px',
    paddingLeft: '16px',
    paddingRight: '16px'
  },
  wordStyle: undefined,
  letterStyle: undefined,
  font_location: getFontFullPath('Inter-Medium.ttf'),
  caps: false,
  line_config: CaptionLineConfig.OneLine,
  font_size: 64,
  transitions: {
    pageIn: TransitionInEffect.None
  }
};

export default corporate;
